function ConvertStringToTree(value, options = {}) {
  let { seperator = '/' } = options

  value = value instanceof Array ? value : [value]

  let result = []

  let createItem = ({ label, value }) => ({ label, value, items: [] })

  value.forEach(entry => {
    let current = result
    let parts = entry.split(seperator)
    let processedParts = []

    parts.forEach(part => {
      processedParts.push(part)

      let match = current.find(r => r.label === part)
      if (match) return (current = match.items)

      let newCategory = createItem({ label: part, value: processedParts.join(seperator) })
      current.push(newCategory)
      return (current = newCategory.items)
    })
  })

  return result
}

export { ConvertStringToTree }
